import axios from "axios";

const getProductDropdownByBranch = async branchUuid => {

    const response = await axios.get('/serialnumber/api/v1/product/get-dropdown-by-branch/' + branchUuid);

    return response.data;
};

export default getProductDropdownByBranch;